import axios from "axios";

export const getMachineSectionsForMachine = async (machineId) => {
    const response = await axios.get(
        `/api/machinesections/machine/${machineId}`
    );

    return response.data;
};

export const createMachineSection = async (machineSection) => {
    const response = await axios.post(
        `/api/machinesections`,
        machineSection
    );

    return response.data;
};

export const updateMachineSection = async (machineSection) => {
    const response = await axios.put(
        `/api/machinesections/${machineSection.id}`,
        machineSection
    );

    return response.data;
};

export const deactivateMachineSection = async (id) => {
    const response = await axios.delete(
        `/api/machinesections/${id}`
    );

    return response.data;
};

export const setMachineSectionStopReasonCodes = async (id, stopReasonCodeIds) => {
    const response = await axios.put(
        `/api/machinesections/${id}/stop-reason-codes`,
        { stopReasonCodeIds }
    );

    return response.data;
};